import { ReactChild, useEffect, useRef } from 'react';

import { IconAngleUp } from '@iwoca/icons';
import { Button } from '@iwoca/orion';
import cn from 'classnames';

import styles from './PlanButton.module.css';
import { useMediaQuery } from '../../../../customHooks/useMediaQuery';
import { PaymentPlanStatus, Plan } from '../Dashboard.types';

const PlanButton = ({
    status,
    selectedPlanId,
    paymentPlan,
    selectPaymentPlan,
    children,
    renderContent
}: {
    status: PaymentPlanStatus | null;
    selectedPlanId: string | null;
    paymentPlan: Plan;
    selectPaymentPlan: (plan: Plan) => void;
    children: ReactChild;
    renderContent?: () => React.ReactNode;
}) => {
    const isMobile = useMediaQuery('(max-width: 1023px)');
    const isSelected = selectedPlanId === paymentPlan!.pay_link_id;

    const sectionRef = useRef<HTMLButtonElement>(null);
    useEffect(() => {
        if (sectionRef.current && isMobile) {
            const adjustedTop =
                sectionRef.current.getBoundingClientRect().top +
                window.scrollY -
                180; // accounts for the sticky header
            window.scrollTo({ top: adjustedTop, behavior: 'smooth' });
        }
    }, [renderContent, isMobile]);

    return (
        <>
            <button
                className={cn(styles.paymentButton, {
                    [styles.active]:
                        selectedPlanId === paymentPlan!.pay_link_id,
                    [styles.paymentOverdue]: status === 'overdue'
                })}
                onClick={() => {
                    if (paymentPlan?.pay_link_id === selectedPlanId) {
                        selectPaymentPlan(null);
                    } else {
                        selectPaymentPlan(paymentPlan);
                    }
                }}
            >
                {children}
            </button>
            {isMobile && isSelected && renderContent && (
                <section className={styles.expandableContent} ref={sectionRef}>
                    {renderContent()}
                    <Button
                        variant="tertiary"
                        className={styles.hideBtn}
                        onClick={() => selectPaymentPlan(null)}
                    >
                        Hide details <IconAngleUp />
                    </Button>
                </section>
            )}
        </>
    );
};

// eslint-disable-next-line import/no-default-export
export default PlanButton;
